// extracted by css-extract-rspack-plugin
export default {"Avatar":"r7FNc"};